const Navigation = [
    { id: 1, title: "Dashboard",       url: "/",                     class: "bi bi-grid-1x2" },
    { id: 2, title: "Flashes",         url: "/flashes",              class: "bi bi-lightning-charge", new: "new" },
    { id: 3, title: "Text To Speech",  url: "/text-to-speech",       class: "bi bi-mic", new: "new" },
    { id: 4, title: "AI Image",        url: "/ai-image-generation",  class: "bi bi-image" },
    { id: 5, title: "Form Builder",    url: "/form-builder",         class: "bi bi-ui-checks-grid", new: "new" },
    { id: 10, title: "Integrations",   url: "/settings/integrations", class: "bi bi-plug", new: "new" },
    { id: 7, title: "History",         url: "/history",              class: "bi bi-clock-history" },
    { id: 8, title: "Product Updates", url: "/product-updates",      class: "bi bi-stars" },
    { id: 9, title: "Settings",        url: "/settings",             class: "bi bi-gear" },
    { id: 6, title: "Support",         url: "/support",              class: "bi bi-life-preserver" },
];

export default Navigation;
